import { render, staticRenderFns } from "./MediaStatistics.vue?vue&type=template&id=706406e6&scoped=true&"
import script from "./MediaStatistics.vue?vue&type=script&lang=js&"
export * from "./MediaStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MediaStatistics.vue?vue&type=style&index=0&id=706406e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706406e6",
  null
  
)

export default component.exports